import SelfService from './pages/SelfService'
const router = [
  {
    path: 'selfservice',
    name: 'selfService',
    component: SelfService,
    meta: {
      requiresAuth: true,
      titleHeader: 'Autogestión'
    }
  }
]
export default router
